import classnames from 'classnames'
import React, { useState } from 'react'
import { Collapse } from 'reactstrap'

const CardGridCustom = ({
  title,
  notifyNumber,
  children,
  paddingTitle = 'mb-3'
}) => (
  <div className="card card-content col">
    <div className="p-0">
      {title && (
        <div
          className={`d-flex align-items-center justify-content-between ${paddingTitle}`}
        >
          <h5 className="m-0 font-size-20 font-w-600 text-primary-dark">
            {' '}
            {title}
          </h5>
          {notifyNumber && (
            <span className="notify  font-w-bold">{notifyNumber}</span>
          )}
        </div>
      )}
      {children}
    </div>
  </div>
)

const CardGridCollapseCustom = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="accordion card-accordion">
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button
            className={classnames(
              'accordion-button',
              'm-0 font-size-20 font-w-600 text-primary-dark d-flex align-items-center justify-content-between',
              {
                collapsed: isOpen
              }
            )}
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            style={{ cursor: 'pointer' }}
          >
            {title}
            <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
          </button>
        </h2>

        <Collapse isOpen={isOpen} className="accordion-collapse">
          <div className="accordion-body pt-1">{children}</div>
        </Collapse>
      </div>
    </div>
  )
}

export { CardGridCustom, CardGridCollapseCustom }
